<style scoped>
    .outer {
        background: var(--color-progress);
        width: 100px;
        height: 10px;
        border-radius: 3px;
    }

    .inner {
        height: 10px;
        border-radius: 3px;
    }

    .outerloss {
        background: var(--color-progress);
        width: 100px;
        height: 10px;
        border-radius: 3px;
    }

    .innerloss {
        /*background:var(--color-danger-light);*/
        height: 10px;
        border-radius: 3px;
        float: right;
    }

    .gen {
        font-size: 13px;
    }

    div {
        /*border: 1px solid yellow;*/
    }
    td {
        /*border: 1px solid lightgreen;*/
    }

    .number {
      width: 82px;
      text-align: center;
    }

    .last {
      width: 100px;
      height: 20px;
      text-align: center;
      /*margin-bottom: 3px;*/
    }

    .so {
      color: #6b74e7;
    }
    .sobackground {
      background: #6b74e7;
    }
    .sotrail {
      color: #8E65E6;
    }
    .sotrailbackground {
      /*background: #6836E2;*/
      background: #8E65E6;
    }
    .slbackground {
      background:var(--color-danger-light);
    }
    .tpbackground {
      background: var(--color-success-light);
    }
    .graybackground {
      background: var(--color-progress-gray);
    }
    .condbackground {
      background: #d09d02;
    }
</style>

<template>
    <div class="gen progress-bar">
        <table>
            <tr>
                <td style="width: 100px; text-align: left">
                  <div v-if="so !== '0' && (!gray || socount > 1) && !sotrailing" style="display: flex; align-items: center">
                    <div class="gred" style="width: 20px; display: flex; flex-direction: column; justify-content: center; align-items: center">
                      <div v-if="sl !== '0'">SL</div>
                      <div v-if="slcPeriod !== ''">{{ slcPeriod }}</div>
                    </div>
                    <div class="so number" :title="tradeside === 'B' ? $text.tr('Покупка') : $text.tr('Продажа')">{{ so }}</div>
                  </div>
                  <div v-else-if="sl !== '0' && !sotrailing" class="number" :style="{ color: parseFloat(slPct) < 0 ? '#AC6A6A' : '#229690' }" style="margin-left: 20px; display: flex; flex-direction: column; justify-content: center; align-items: center" title="Stop Loss">
                    <div>{{ sl }}<br>{{ slPct }}%</div>
                    <div v-if="slcPeriod !== ''">{{ slcPeriod }}</div>
                  </div>
                  <div v-else-if="(trade.Status === 'ORDSUBMIT' && trade.Info && trade.Info.SlPct !== '0') || (sotrailing && sl !== '0')" style="display: flex; align-items: center">
                    <div style="width: 20px"></div>
                    <div class="gred number" style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                      <div>SL</div>
                      <div v-if="slcPeriod !== ''">{{ slcPeriod }}</div>
                    </div>
                  </div>
                </td>
<!--              ЛЕВАЯ ШКАЛА-->
                <td>
                  <div class="last"><div v-if="lossPct !== '0px'" :title="$text.tr('Цена сейчас')">{{ last }}</div></div>
                    <div class="outerloss">
<!--                      <div class="innerloss" :style="{ width: lossPct,  background: so !== '0' ? '#6b74e7' : '--color-danger-light'}"></div>-->
                      <div class="innerloss" :class="{ sobackground: so !== '0', slbackground:  so === '0' && !sotrailing, condbackground:  conditional, sotrailbackground: sotrailing}" :style="{ width: lossPct }"></div>
                    </div>
                  <div class="last">
                    <div v-if="sotrailing" class="sotrail">TRAILING {{ sotrailingpct }}%</div>
                    <div v-else-if="so !== '0' && !gray" class="so">
                      <span v-if="tradeside === 'B'">BUY</span>
                      <span v-else>SELL</span>
                      <span v-if="socount > 1"> 1 {{ $text.tr('из') }} {{ socount }}</span>
                    </div>
                  </div>
                </td>
<!--              СЕРЕДИНА-->
                <td class="number">
                  <div style="color: var(--color-neutral-light)" :title="$text.tr('Цена входа')">
                    <span v-if="conditional && lossPct !== '0px' && tradeside == 'B'" style="font-size: 16px">≥</span>
                    <span v-if="conditional && profitPct !== '0px' && tradeside == 'S'" style="font-size: 16px">≥</span>
                    <span v-if="conditional && profitPct !== '0px' && tradeside == 'B'" style="font-size: 16px">≤</span>
                    <span v-if="conditional && lossPct !== '0px' && tradeside == 'S'" style="font-size: 16px">≤</span>
                    {{ tradeprice }}</div>
                  <div style="color: #737691">
                    <span :title="profitpctlvrg === profitpct ? '' : $text.tr('С учетом плеча: ') + profitpctlvrg + '%'" v-if="!gray && !conditional" :class="{ggreen: profitpct >= 0 && !gray, gred: profitpct < 0 && !gray}">
                      {{ profitpct }}%<br>
                      <div v-if="!$store.state.trades.profitInQuote" :title="'uPnL: ' + trade.Upnl" style="font-weight: bold" @click="changeProfitC" :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ profitUSD }}</div></div>
                      <div v-else style="font-weight: bold" :title="'uPnL: ' + trade.Upnl" @click="changeProfitC" :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ profitstr[0] }}<br>{{ profitstr[1] }}</div></div>
                    </span>
                    <span v-else>{{ lastPct }}%</span>
                  </div>
                </td>
<!--              ПРАВАЯ ШКАЛА-->
                <td>
                  <div class="last"><div v-if="profitPct !== '0px'" :title="$text.tr('Цена сейчас')">{{ last }}</div></div>
                  <div class="outer" :title="gray ? $text.tr('Ордер размещен') : ''">
<!--                    <div class="inner" :style="{ width: profitPct, background: gray ? '#4f526e' : 'var(--color-success-light)' }"></div>-->
                    <div class="inner" :class="{ graybackground: gray, tpbackground: !gray, condbackground: conditional}" :style="{ width: profitPct}"></div>
                  </div>
                  <div class="last ggreen">
                    <div v-if="trailing">TP TRAILING</div>
                    <div v-else-if="stepscount > 1" style="text-align: center;">TP {{ curstep }} {{ $text.tr('из') }} {{ stepscount }}</div>
                  </div>
                </td>
                <td  style="width: 100px">
                  <div v-if="tp !== '0'" class="number" :style="{color: parseFloat(sellPct) > 0 ? '#28948f' : '#AC6A6A'}" title="Take Profit">{{ tp }}<br>{{ sellPct }}%</div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Trade, So } from '@/util/types'
import Decimal from 'decimal.js'

@Component
export default class ProgressBar extends Vue {
  @Prop() private tradeside!: string
  @Prop() private sl!: string
  @Prop() private tp!: string
  @Prop() private curstep!: number
  @Prop() private stepscount!: number
  @Prop() private so!: string
  @Prop() private socount!: number
  @Prop() private last!: string
  @Prop() private profitstr!: string
  @Prop() private profitusd!: string
  // @Prop() private profitpct!: string;
  @Prop() private profitpctlvrg!: string
  @Prop() private gray!: boolean
  @Prop() private conditional!: boolean
  @Prop() private trailing!: boolean
  @Prop() private trade!: Trade

  get slcPeriod () {
    if (this.trade.Sl && this.trade.Sl.length > 0) {
      const p = this.slcPeriods().filter(period => period.min === this.trade.Sl[0].Slcperiod)
      if (p.length > 0) {
        return p[0].interval
      }
    }
    return ''
  }

  get profitpct () {
    if (this.trade.Info && this.trade.Info.Leverage) {
      return new Decimal(this.trade.ProfitPct).div(this.trade.Info.Leverage).toDP(2).toString()
    } else {
      return this.trade.ProfitPct
    }
  }

  get tradeprice () {
    let price = this.trade.Price
    if (this.trade.Sos && this.trade.Sos.length > 0 && this.trade.Status === 'ORDSUBMIT') {
      price = this.trade.Sos[0].Price
      this.trade.Sos.forEach((so: So) => {
        if (so.Trail) {
          if (this.trade.Side === 'B' && parseFloat(so.Price) < parseFloat(price)) {
            price = so.Price
          }
          if (this.trade.Side === 'S' && parseFloat(so.Price) > parseFloat(price)) {
            price = so.Price
          }
        }
      })
    }
    return price
  }

  get sotrailingpct () {
    let trailpct = ''
    if (this.trade.Sos && this.trade.Sos.length > 0) {
      let price = this.trade.Sos[0].Price
      this.trade.Sos.forEach((so: So) => {
        if (so.Trail) {
          if (trailpct === '') {
            trailpct = so.Trailpct
          }
          if (this.trade.Side === 'B' && parseFloat(so.Price) < parseFloat(price)) {
            trailpct = so.Trailpct
            price = so.Price
          }
          if (this.trade.Side === 'S' && parseFloat(so.Price) > parseFloat(price)) {
            trailpct = so.Trailpct
            price = so.Price
          }
        }
      })
    }
    return trailpct
  }

  get sotrailing () {
    let trail = false
    if (this.trade.Sos && this.trade.Sos.length > 0) {
      this.trade.Sos.forEach((so: So) => {
        if (so.Trail) {
          trail = true
        }
      })
    }
    return trail
  }

  get profitUSD () {
    if (parseFloat(this.profitusd) < 0) {
      const profit = new Decimal(this.profitusd).neg().toString()
      return '-$' + profit
    }
    return '$' + this.profitusd
  }

  get lastPct () {
    const pct = new Decimal(this.last).sub(this.tradeprice).div(this.tradeprice).mul(100).toDecimalPlaces(2)
    return pct.toNumber()
  }

  get profitPct () {
    let diff = new Decimal(this.tradeprice).mul(0.1)
    if (this.tp && this.tp !== '0') {
      if (this.tradeside === 'B') {
        if (new Decimal(this.tp).lessThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.tp).sub(this.tradeprice)
      } else {
        if (new Decimal(this.tp).greaterThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.tradeprice).sub(this.tp)
      }
    }
    let pct: Decimal
    if (this.tradeside === 'B') {
      pct = new Decimal(this.last).sub(this.tradeprice).div(diff).mul(100).toDecimalPlaces(0)
    } else {
      pct = new Decimal(this.tradeprice).sub(this.last).div(diff).mul(100).toDecimalPlaces(0)
    }
    // console.log('pct', pct.toString())
    if (pct.lessThan(0)) {
      pct = new Decimal(0)
    }
    if (pct.greaterThan(100)) {
      pct = new Decimal(100)
    }
    return pct.toString() + 'px'
    // if (new Decimal(this.sell))
  }

  get lossPct () {
    let diff = new Decimal(this.tradeprice).mul(0.1)
    if (this.sotrailing) {
      if (this.tradeside === 'B') {
        if (new Decimal(this.trade.PriceNow).greaterThan(this.tradeprice)) {
          return '0px'
        }
      } else {
        if (new Decimal(this.trade.PriceNow).lessThan(this.tradeprice)) {
          return '0px'
        }
      }
      diff = new Decimal(this.tradeprice).div(100).mul(this.sotrailingpct).abs()
      // console.log('diff', diff.toString())
    } else if (this.so && this.so !== '0') {
      if (this.tradeside === 'B') {
        if (new Decimal(this.so).greaterThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.tradeprice).sub(this.so).abs()
      } else {
        if (new Decimal(this.so).lessThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.so).sub(this.tradeprice).abs()
      }
    } else if (this.sl && this.sl !== '0') {
      if (this.tradeside === 'B') {
        if (new Decimal(this.sl).greaterThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.tradeprice).sub(this.sl).abs()
      } else {
        if (new Decimal(this.sl).lessThan(this.tradeprice)) {
          return '0px'
        }
        diff = new Decimal(this.sl).sub(this.tradeprice).abs()
      }
    }
    let pct: Decimal
    if (this.tradeside === 'B') {
      pct = new Decimal(this.last).sub(this.tradeprice).div(diff).mul(100).toDecimalPlaces(0)
    } else {
      pct = new Decimal(this.tradeprice).sub(this.last).div(diff).mul(100).toDecimalPlaces(0)
    }
    // console.log('pct', pct.toString())
    if (pct.greaterThan(0)) {
      pct = new Decimal(0)
    }
    if (pct.lessThan(-100)) {
      pct = new Decimal(-100)
    }
    return pct.abs().toString() + 'px'
    // if (new Decimal(this.sell))
  }

  get slPct () {
    let pct = new Decimal(this.sl).sub(this.tradeprice).mul(100).div(this.tradeprice).toDecimalPlaces(2)
    if (this.tradeside === 'S') {
      pct = pct.neg()
    }
    return pct.toString()
  }

  get sellPct () {
    let pct = new Decimal(this.tp).sub(this.tradeprice).mul(100).div(this.tradeprice).toDecimalPlaces(2)
    if (this.tradeside === 'S') {
      pct = pct.neg()
    }
    return pct.toString()
  }

  slcPeriods () {
    if (this.trade.ExchId === 'FTX') {
      return [
        { min: 1, interval: '1m' },
        { min: 5, interval: '5m' },
        { min: 15, interval: '15m' },
        { min: 60, interval: '1h' },
        { min: 240, interval: '4h' },
        { min: 1440, interval: '1D' }
      ]
    } else {
      return [
        { min: 1, interval: '1m' },
        { min: 5, interval: '5m' },
        { min: 15, interval: '15m' },
        { min: 30, interval: '30m' },
        { min: 60, interval: '1h' },
        { min: 120, interval: '2h' },
        { min: 240, interval: '4h' },
        { min: 360, interval: '6h' },
        { min: 720, interval: '12h' },
        { min: 1440, interval: '1D' }
      ]
    }
  }

  changeProfitC () {
    // @ts-ignore
    this.$store.state.trades.profitInQuote = !this.$store.state.trades.profitInQuote
    // @ts-ignore
    localStorage.setItem('capico_profitinquote', this.$store.state.trades.profitInQuote)
  }
}
</script>
